import { Container, Grid, Link, Box, List, ListItem } from '@mui/material';
import React from 'react';
import PricingCompScss from './PricingComp.module.scss';
import { PricingData } from '../../Data/pricingData';

function PricingComp() {
    return (
        <div>
            <section id={PricingCompScss.pricing}>
                <Container maxWidth='lg'>
                    <Box className={PricingCompScss.pricingHead}>
                        <span>answer anything</span>
                        <h2>Our pricing plan</h2>
                    </Box>
                    <Grid container sx={{ mx: '-15px', width: 'auto' }} className={PricingCompScss.pricingBody}>
                        {
                            PricingData.map(priData =>

                                <Grid item xs={12} sm={6} md={4} sx={{ px: '15px' }} key={priData.id}>
                                    <Box className={PricingCompScss.pricingBodyItem}>
                                        <Box className={PricingCompScss.pricingBodyItemHead}>
                                            <h4>{priData.price}<span>$</span></h4>
                                            <Box className={PricingCompScss.pricingBodyItemHeadInfo}>
                                                <span>monthly</span>
                                            </Box>
                                        </Box>
                                        <span className={PricingCompScss.pricingBodyItemCategory}>{priData.category}</span>
                                        <List className={PricingCompScss.pricingBodyItemList}>
                                            <ListItem>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z" /></svg>
                                                Branding strategy & identity
                                            </ListItem>
                                            <ListItem>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z" /></svg>
                                                Marketing campaign & PR
                                            </ListItem>
                                            <ListItem>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z" /></svg>
                                                Website and app desinging
                                            </ListItem>
                                            <ListItem>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z" /></svg>
                                                Video production & editing
                                            </ListItem>
                                        </List>
                                        <Box className={PricingCompScss.pricingBodyItemButBox}>
                                            <Link href="#" className={PricingCompScss.pricingBodyItemLink}>
                                                sign up
                                            </Link>
                                        </Box>
                                    </Box>
                                </Grid>
                            )
                        }
                    </Grid>
                </Container>
            </section>
        </div>
    )
}

export default PricingComp;
